import { Form } from 'antd'

import PageWrap from '../../components/layout/PageWrap'
import FormWrap from '../../components/forms/FormWrap'
import FormBlock from '../../components/forms/FormBlock'

import { TagDescription } from '../../constants/forms/ProductTags'
import { CreateProductTag as request } from '../../network/ProductTags'

const CreateProductTag = () => {
    const [form] = Form.useForm()

    return (
        <PageWrap goBack title="PRODUCT_TAGS_CREATE_TAG">
            <FormWrap
                title="create_product_tag"
                request={request}
                onSuccess={'/product-tags'}
                onCancel={'/product-tags'}
                invalidate={['getProductTags']}
            >
                <div className="SectionVerticalWrap">
                    <FormBlock form={form} formTemplate={TagDescription} />
                </div>
            </FormWrap>
        </PageWrap>
    )
}

export default CreateProductTag
